import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Grid, Col, Row } from '@bingads-webui-react/primitive';
import ButtonAction from './button-action';

export default class Item extends PureComponent {
  static defaultProps = {
    disabled: false,
  }

  renderSourceItem = (value, selected, onChange, disabled) => (
    <Row>
      <Col sm={10} disabled={disabled}>
        {value}
      </Col>
      {
        disabled ?
          null :
          <Col sm={2}>
            <ButtonAction
              value={value}
              selected={selected}
              onClick={onChange}
              disabled={disabled}
              actionLabel={this.props.i18n.getString('DoubleListBox_Add')}
            />
          </Col>
      }
    </Row>
  )

  renderSelectedItem = (value, selected, onChange) => (
    <Row>
      <Col sm={2}>
        <ButtonAction
          value={value}
          selected={selected}
          onClick={onChange}
          actionLabel={this.props.i18n.getString('DoubleListBox_Remove')}
        />
      </Col>
      <Col sm={10}>
        {value}
      </Col>
    </Row>
  )

  render() {
    const {
      value,
      selected,
      onChange,
      disabled,
      className,
    } = this.props;

    return (
      <Grid fluid className={`item ${className}`}>
        {
          selected ?
          this.renderSelectedItem(value, selected, onChange) :
          this.renderSourceItem(value, selected, onChange, disabled)
        }
      </Grid>
    );
  }
}

Item.propTypes = {
  value: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  className: PropTypes.string,
};

Item.defaultProps = {
  className: '',
};
